import get from 'lodash/get';

export const getBusinessAccounts = state =>
  get(state.auth.user, 'businessAccounts', []);
